"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOperations = void 0;
const network_1 = __importDefault(require("@ledgerhq/live-network/network"));
const bignumber_js_1 = require("bignumber.js");
const live_env_1 = require("@ledgerhq/live-env");
const operation_1 = require("../../../operation");
const DEFAULT_TRANSACTIONS_LIMIT = 100;
const getIndexerUrl = (route) => `${(0, live_env_1.getEnv)("API_NEAR_INDEXER")}${route || ""}`;
const fetchTransactions = (address, limit = DEFAULT_TRANSACTIONS_LIMIT) => __awaiter(void 0, void 0, void 0, function* () {
    const route = `/transactions?limit=${limit}&account=${address}&date=${new Date().getTime()}`;
    const { data } = yield (0, network_1.default)({
        method: "GET",
        url: getIndexerUrl(route),
    });
    return (data === null || data === void 0 ? void 0 : data.records) || [];
});
function isSender(transaction, address) {
    return transaction.sender === address;
}
function getOperationType(transaction, address) {
    var _a, _b;
    switch ((_b = (_a = transaction.actions[0]) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.method_name) {
        case "deposit_and_stake":
            return "STAKE";
        case "unstake":
        case "unstake_all":
            return "UNSTAKE";
        case "withdraw":
        case "withdraw_all":
            return "WITHDRAW_UNSTAKED";
        default:
            return isSender(transaction, address) ? "OUT" : "IN";
    }
}
function getOperationValue(transaction, type) {
    const amount = transaction.actions[0].data.deposit || 0;
    if (type === "OUT") {
        return new bignumber_js_1.BigNumber(amount).plus(transaction.fee);
    }
    return new bignumber_js_1.BigNumber(amount);
}
function transactionToOperation(accountId, address, transaction) {
    return __awaiter(this, void 0, void 0, function* () {
        const type = getOperationType(transaction, address);
        return {
            id: (0, operation_1.encodeOperationId)(accountId, transaction.hash, type),
            accountId,
            fee: new bignumber_js_1.BigNumber(transaction.fee || 0),
            value: getOperationValue(transaction, type),
            type,
            hash: transaction.hash,
            blockHash: transaction.block_hash,
            blockHeight: transaction.height,
            date: new Date(transaction.time),
            extra: {},
            senders: transaction.sender ? [transaction.sender] : [],
            recipients: transaction.receiver ? [transaction.receiver] : [],
            hasFailed: !transaction.success,
        };
    });
}
const getOperations = (accountId, address) => __awaiter(void 0, void 0, void 0, function* () {
    const rawTransactions = yield fetchTransactions(address);
    return yield Promise.all(rawTransactions.map(transaction => transactionToOperation(accountId, address, transaction)));
});
exports.getOperations = getOperations;
//# sourceMappingURL=datahub-indexer-sdk.js.map